var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 6v8a1 1 0 0 0 1 1h3V5H1a1 1 0 0 0-1 1ZM14.153 6H11.2a.491.491 0 0 1-.43-.247.492.492 0 0 1-.007-.496l1.041-1.875c.229-.411.252-.894.065-1.325a1.488 1.488 0 0 0-1.013-.858l-.734-.184a.499.499 0 0 0-.493.15l-3.987 4.43A2.499 2.499 0 0 0 5 7.267V12.5C5 13.878 6.122 15 7.5 15h4.974a2.506 2.506 0 0 0 2.411-1.84l1.068-4.898A1.849 1.849 0 0 0 14.153 6Z",
  fill: "gray",
  className: "like_svg__color000000 like_svg__svgShape"
})));
export default SvgLike;